/**
 * AccordionHeader - clickable accordion header that toggles its body panel.
 * Custom element: <accordion-header>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import { dist } from "./vendor.js";
class AccordionHeader extends ThemeComponent {
  constructor() {
    super(...arguments), this.open = "", this._onOpenChange = new dist.SimpleEventDispatcher();
  }
  get onOpenChange() {
    return this._onOpenChange.asEvent();
  }
  changeOpen(openState) {
    this.open = openState, this._onOpenChange.dispatch(openState);
  }
  init() {
    this.$listen(this, "click", () => {
      this._onOpenChange.dispatch(this.open);
    });
  }
}
setFunctionName(AccordionHeader, "AccordionHeader");
const propertyTypes = {};
AccordionHeader.prototype.$name = "AccordionHeader";
AccordionHeader.prototype.$info = JSON.parse('{"name":"AccordionHeader","meta":{"isLegacy":false,"selector":"accordion-header"},"props":[],"refs":[]}');
AccordionHeader.prototype.$info.component = AccordionHeader;
for (const prop of AccordionHeader.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Accordion/AccordionHeader.ts", {
  AccordionHeader: AccordionHeader
}, void 0);